import axios from '../../_utils/axios';
import store, { DELETE_LOADER, persistor } from '../../../store';
import { format } from '../../../utils/format';

// ----------------------------------------------------------------------

const getTemperature = async (
  id: string,
  startDate: string,
  endDate: string,
) => {
  const start = format(new Date(startDate), 'setting', 'start');
  const end = format(new Date(endDate), 'setting', 'end');

  return await axios.get(`real-time-status/iot-groups/${id}/recently/water-temperature?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      const code = error.response.data.code;
      
      if ( error.code === 'ERR_BAD_RESPONSE' ) {
        persistor.purge();
        return window.location.href = '/alert';
      } else if ( code === 'ERR-001' || code === 'ERR-REISSUE' ) {
        persistor.purge();
        return window.location.href = '/login';
      } else {
        return Promise.reject(error);
      }
    })
    .finally(() => store.dispatch( DELETE_LOADER() ));
};

export default getTemperature;